import en from './en';
import nl from './nl';
import de from './de';
import fr from './fr';
import es from './es';

// Localized legal content (Privacy Policy, Terms of Use, Disclaimer) for all
// supported languages. English is the canonical source / fallback.
export const LEGAL_CONTENT = { en, nl, de, fr, es };

export function getLegalBundle(lang) {
  return LEGAL_CONTENT[lang] || LEGAL_CONTENT.en;
}
